import { createFileRoute } from "@tanstack/react-router";

import { HubPage } from "@/components/hub-page";

const TITLE = "Write — Texts & Essays | Luiza Jesus do Prado";
const DESC =
  "Texts, essays and research writing by Luiza Jesus do Prado on art, mental health, decolonization and the body.";

export const Route = createFileRoute("/write")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://www.luizajesusdoprado.com/write" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: WritePage,
});

function WritePage() {
  return (
    <HubPage
      kicker="Texts · Essays · Research"
      title="Write"
      intro="Writing on art, mental health, decolonization and the body — essays, research texts and the words that accompany the works."
      sections={[
        {
          title: "Essays on the site",
          links: [
            { label: "Decolonial art", href: "/themes/decolonial-art" },
            { label: "Art, Science & Technology", href: "/themes/art-science-technology" },
            { label: "Decolonization & Mental Health", href: "/themes/decolonization-mental-health" },
            { label: "Sexuality & Gender", href: "/themes/sexuality-gender" },
            { label: "What Is Madness?", href: "/work/what-is-madness" },
          ],
        },
        {
          title: "Press & documents",
          links: [
            { label: "Clipping", href: "/clipping" },
            { label: "Portfolios", meta: "PDFs · Dropbox ↗", href: "https://www.dropbox.com/scl/fo/18z17289exddhmcuid3gp/AF6oSFShmHr-uPUCOs5m2Cg?rlkey=ymnufldogb1lwl0btcxfx8olj&dl=0" },
            { label: "Twitter", meta: "↗", href: "https://twitter.com/luizajdoprado" },
          ],
        },
      ]}
    />
  );
}
